import React, { useEffect } from 'react';
import {  useFormikContext } from 'formik';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { FormLabel } from './FormLabel';
import { useEdit } from '../../Services/EditContext';
import parse from 'html-react-parser';
import ErrorMessage from './ErrorMessage'
import { useRef } from 'react';

const RichTextEditor = ({ id, label ,setEditor,value, onChange}) => {
    const formikContext = useFormikContext();
    const values = formikContext?.values;
    const setFieldValue = formikContext?.setFieldValue; 

    const fieldValue = id && values && values[id] ? values[id] :value;
    const editarr = useEdit();
    const edit = editarr && editarr.length > 0?editarr[0]:true; 
    const editorRef = useRef(); 
    const onChangeEditor = (content) => {
        setFieldValue && setFieldValue(id, content);
        onChange && onChange(content);
    }
    useEffect(() => {
        // Get underlining core object here
        // Notice that useEffect is been used because you have to make sure the editor is rendered.
        setEditor && setEditor(editorRef.current?.editor)
    }, [setEditor]);
    


    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {edit ? <SunEditor ref={editorRef} setOptions={{
            height: 200,
            buttonList: [
                ['undo', 'redo',
                    'font', 'fontSize', 'formatBlock',
                    'paragraphStyle', 'blockquote',
                    'bold', 'underline', 'italic', 'strike', 'subscript', 'superscript',
                    'fontColor', 'hiliteColor', 'textStyle',
                    'removeFormat',
                    'outdent', 'indent',
                    'align', 'horizontalRule', 'list', 'lineHeight',
                    'table', 'link', 'image', 'video', 'audio', /** 'math', */ // You must add the 'katex' library at options to use the 'math' plugin.
                    /** 'imageGallery', */ // You must add the "imageGalleryUrl".
                    'fullScreen', 'showBlocks', 'codeView',
                    'preview', 'print', 'save', 'template']
            ] // Or Array of button list, eg. [['font', 'align'], ['image']]
            // Other option
        }} setContents={fieldValue} onChange={onChangeEditor} />
            : parse(fieldValue)}
        <ErrorMessage name={id} />
    </React.Fragment>
}
export default RichTextEditor; 